import styled from '@emotion/styled'

import { spacing } from '@orus.eu/pharaoh'
import { stickyHeaderZIndex } from '@orus.eu/pharaoh/src/code-only/z-indexes'
import { borderStroke } from '@orus.eu/pharaoh/src/foundations/border-stroke-tokens'
import { colorTokens } from '@orus.eu/pharaoh/src/foundations/color-tokens'

export const StickyHeaderContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: ${stickyHeaderZIndex};
  background-color: ${colorTokens['color-bg-base-normal']};
  border-bottom: ${borderStroke[20]} solid ${colorTokens['color-stroke-base-basic']};
  padding: ${spacing[50]} ${spacing[60]};
`
